// *   File : accordion-2.js
//  *   Author : https://evoqins.com
//  *   Description : accordion-2 component
//  *   Integrations : NA
//  *   Version : 1.0.0
//  */

import React, { useRef, useEffect, useState } from "react";
import Icon from "../icons";
import { PrimaryButton } from "../Buttons";
import parse from "html-react-parser";

export default function Accordion2({
  title,
  isOpen,
  onClick,
  content,
  handleDelete,
  handleEdit,
}) {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen) {
      const scrollHeight = contentRef.current.scrollHeight;
      setHeight(scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <div
      onClick={onClick}
      className={`e-cursor-pointer ${
        isOpen ? "bg-white bg-opacity-100" : "bg-transparent"
      } p-3 d-flex flex-column row-gap-2 w-100 border-bottom border-white rounded-12`}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center w-100 text-black">
        <h6 className="m-0 fs-14 lh-20 fw-500">{title}</h6>
        <Icon icon={isOpen ? "chevron-up" : "chevron-down"} size="20px" />
      </div>

      {/* Animated Body */}
      <div
        ref={contentRef}
        className="w-100"
        style={{
          maxHeight: height,
          opacity: isOpen ? 1 : 0,
          transition: "max-height 0.35s ease, opacity 0.25s ease",
          overflow: "hidden",
        }}
      >
        <div className="mt-1 w-100">
          <div className="fw-400 fs-14 lh-20 text-davys-gray mb-2">
            {typeof content === "string" ? parse(content) : content}
          </div>
          <div className="d-flex col-g-24">
            <PrimaryButton
              ClassName="bg-transparent e-w-fit fs-14 fw-500 text-facebook-blue p-0 me-2 rounded-0 e-border-bottom-dashed-blue "
              name="Delete"
              onPress={handleDelete}
            />
            <PrimaryButton
              ClassName="bg-transparent e-w-fit fs-14 fw-500 text-facebook-blue p-0  ms-1 rounded-0 e-border-bottom-dashed-blue "
              name="Edit"
              onPress={handleEdit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
